(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-text-expand]').forEach((wrapper) => {
    const text = wrapper.querySelector('.text-block--expandable');
    const toggle = wrapper.querySelector('[data-text-expand-toggle]');

    if (!text || !toggle) return;

    const checkOverflow = () => {
      wrapper.classList.remove('is-expanded');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'Leggi di più';

      requestAnimationFrame(() => {
        wrapper.classList.toggle('is-overflowing', text.scrollHeight > text.clientHeight + 1);
      });
    };

    toggle.addEventListener('click', () => {
      const isExpanded = wrapper.classList.toggle('is-expanded');

      toggle.setAttribute('aria-expanded', String(isExpanded));
      toggle.textContent = isExpanded ? 'Chiudi' : 'Leggi di più';
    });

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
  });
  } catch(e) { console.error(e); }
})();

})();
